import type { CrudModalField } from "@/components/tables/fields/crudModalField";

export interface EntityRequestContext {
  subdomain: string;
  globalSubjectValue?: unknown;
  companySubjectId?: string;
  subjectIdForBuildings?: unknown;
  limit?: string;
}

export const buildEntityRequestParameters = (
  field: Pick<
    CrudModalField,
    | "entity"
    | "useGlobalStateToImpersonate"
    | "additionalUrlParameters"
    | "getOnlyActiveUsers"
    | "additionalRoutePartsforGet"
  >,
  ctx: EntityRequestContext
) => {
  const additionalUrlParameters: Record<string, any> = {};
  if (field.entity === "department" && ctx.subdomain === "admin") {
    additionalUrlParameters["impersonate_subject"] =
      field.useGlobalStateToImpersonate
        ? ctx.globalSubjectValue
        : ctx.companySubjectId;
  }
  if (field.additionalUrlParameters) {
    for (const key in field.additionalUrlParameters) {
      additionalUrlParameters[key] = field.additionalUrlParameters[key];
    }
  }
  if (field.entity === "building" && ctx.subdomain === "admin") {
    additionalUrlParameters["subject"] = ctx.subjectIdForBuildings
      ? ctx.subjectIdForBuildings
      : ctx.companySubjectId;
  }
  if (field.entity === "user" && field.getOnlyActiveUsers) {
    additionalUrlParameters["impersonate_subject"] =
      field.getOnlyActiveUsers.companySubjectId;
    additionalUrlParameters["is_active"] = field.getOnlyActiveUsers.status;
  }

  const parametersToRender: Record<string, any> = {
    additionalUrlParameters,
    depth: "0",
  };
  if (ctx.limit !== undefined) {
    parametersToRender["limit"] = ctx.limit;
  }

  return {
    parametersToRender,
    additionalRouteParts: field.additionalRoutePartsforGet
      ? field.additionalRoutePartsforGet
      : {},
  };
};
